<template>
  <fragment>
    <input
      :id="inputId"
      type="radio"
      :data-handle="shopifyData.handle"
      :name="shopifyData.name"
      :value="shopifyData.value"
      :class="[
        `checkbox sr-only ${shopifyData.name || ''} ${
          shopifyData.selectId || ''
        }`,
      ]"
      :data-vid="shopifyData.vid"
      :data-preorder="shopifyData.preorder"
      :data-shippingnote="shopifyData.shippingNote"
      :data-description="shopifyData.description"
      v-bind:[additionalAttributes]="true"
      :checked="checked"
      data-mtr-track="change"
      data-mtr-as="clickProductSwatch"
      :data-mtr-data="JSON.stringify(eventPayload)"
      @click="clickHandler"
      :aria-label="`${shopifyData.name}: ${shopifyData.value}`"
    />
    <label
      :class="[
        `radio f aic bg-${valueHandle || ''} oos-${shopifyData.oos || ''}`,
      ]"
      :for="inputId"
    >
    </label>
  </fragment>
</template>

<script>
import { handleize, getQueryStringParameter } from "@/lib/utils";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "component-radio",
  props: {
    shopifyData: {
      selectId: String,
      label: String,
      name: String,
      value: String,
      vid: String,
      handle: String,
      preorder: Boolean,
      attributes: String,
      description: String,
      shippingNote: String,
      checked: Boolean,
      oos: Boolean,
      productHandle: String,
    },
    maestroData: {
      bundleName: String,
      productName: String,
      productColor: String,
    },
  },
  computed: {
    valueHandle() {
      return handleize(this.shopifyData.value);
    },
    inputId() {
      return this.shopifyData.selectId || "" + this.shopifyData.label || "";
    },
    additionalAttributes() {
      if (!this.shopifyData.attributes) return null;
      return this.shopifyData.attributes;
    },
    eventPayload() {
      const data = {
        "product name": this.maestroData.productName,
        "product color": this.maestroData.productColor,
      };
      if (this.maestroData.bundleName) {
        data["bundle name"] = this.maestroData.bundleName;
      }

      return data;
    },
    checked() {
      const data = this.shopifyData;
      const param = getQueryStringParameter(data.name.toLowerCase());
      if (param && param.toLowerCase() === data.value.toLowerCase()) {
        return true;
      } else {
        return data.checked;
      }
    },
  },
  methods: {
    ...mapActions({
      updateVariant: "product/updateVariant",
    }),
    ...mapGetters({
      selectedVariantString: "product/selectedVariantString",
    }),
    clickHandler() {
      this.setPermalink();
      this.setSelectedVariantOption();
      this.variantSelectedEvent();
    },
    setPermalink() {
      const data = this.shopifyData;
      const url = new URL(window.location);

      url.searchParams.set(data.name.toLowerCase(), data.value.toLowerCase());
      history.replaceState({}, "", url);
    },
    setSelectedVariantOption() {
      const option = {};
      const data = this.shopifyData;
      option[data.name.toLowerCase()] = data.label;
      this.updateVariant(option);
    },
    variantSelectedEvent() {
      const variantSelectedEvent = new CustomEvent("variant-selected:id", {
        detail: {
          product: this.shopifyData.productHandle,
          variant: this.selectedVariantString(),
        },
      });
      window.dispatchEvent(variantSelectedEvent);
    },
  },
  async mounted() {
    const data = this.shopifyData;
    if (!getQueryStringParameter(data.name) && data.checked) {
      this.setPermalink();
    }

    window.addEventListener("product-carousel:mounted", async () => {
      if (this.checked) {
        this.setSelectedVariantOption();
        await this.$nextTick();
        this.variantSelectedEvent();
      }
    });
  },
};
</script>
